var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.backUpAppShowSwitch)?_c('BackUpAppRecommend'):_vm._e(),_c('hot-apps'),_c('daily-challenge'),(_vm.isCasinoEnabled)?_c('casino-entry'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }